import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GearComponent } from './pages/gear/gear.component';
import { JewelsComponent } from './pages/jewels/jewels.component';
import { OneHandedWeaponPiercingComponent } from './pages/one-handed-weapon-piercing/one-handed-weapon-piercing.component';
import { TwoHandedWeaponPiercingComponent } from './pages/two-handed-weapon-piercing/two-handed-weapon-piercing.component';
import { SuitPiercingComponent } from './pages/suit-piercing/suit-piercing.component';
import { DailyCalculatorComponent } from './pages/daily-calculator/daily-calculator.component';
import { UltiJewelsComponent } from './pages/ulti-jewels/ulti-jewels.component';
import { UltiWeaponComponent } from './pages/ulti-weapon/ulti-weapon.component';

const routes: Routes = [
  { path: '', component: GearComponent },
  { path: 'gear', component: GearComponent},
  { path: 'ulti-weapon', component: UltiWeaponComponent},
  { path: 'ulti-jewels', component: UltiJewelsComponent},
  { path: '1h-weapon-piercing', component: OneHandedWeaponPiercingComponent},
  { path: '2h-weapon-piercing', component: TwoHandedWeaponPiercingComponent},
  { path: 'suit-piercing', component: SuitPiercingComponent},
  { path: 'jewels', component: JewelsComponent},
  { path: 'daily-calculator', component: DailyCalculatorComponent },
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
